import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//theme
import { homeColor } from '@/theme/ai';

export const StackSection = styled.section`
  border-top: 1px solid ${homeColor.carbon};
  background: radial-gradient(
    ellipse 90% 140% at 50% 100%,
    #0f555c 0%,
    #0a282d 46%,
    ${homeColor.bg} 85%
  );
  padding: 40px 0;

  ${screen.md} {
    padding: 60px 0;
  }

  ${screen.lg} {
    padding: 80px 0;
  }

  ${screen.xxlg} {
    padding: 100px 0;
  }
`;

export const StackWrap = styled.div`
  max-width: 968px;
`;

export const StackDescription = styled.p`
  font-family: inherit;
  font-weight: 500;
  font-size: 17px;
  line-height: 1.6;
  color: ${homeColor.muted};
  margin: 16px 0 0;
  max-width: 530px;
`;

export const DiagramWrap = styled.div`
  margin-top: 48px;
`;

export const DiagramSvg = styled.svg`
  width: 100%;
  display: block;
`;
